import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-bone pt-24 pb-8 px-6 md:px-12 border-t border-ink/10" data-id="element-276">
      <div className="max-w-[1280px] mx-auto" data-id="element-277">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20" data-id="element-278">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-279">
            <Link to="/" className="flex items-center gap-3 mb-6" data-id="element-280">
              <img src="https://cdn.magicpatterns.com/uploads/6F22E2Ctxndm5LAy6tPVXu/pasted-image.png" alt="Zylus Homes" className="h-12 w-auto" data-id="element-281" />
              <div className="flex flex-col leading-tight" data-id="element-282">
                <span className="font-serif text-xl tracking-tight text-ink font-medium" data-id="element-283">
                  Zylus
                </span>
                <span className="text-[9px] font-bold tracking-[0.2em] uppercase text-gold-dark -mt-0.5" data-id="element-284">
                  Homes & Property
                </span>
              </div>
            </Link>
            <p className="text-ink/60 text-sm leading-relaxed mb-3" data-id="element-285">
              Building strong, sustainable, proactive and long-term
              relationships with both corporate and private clients.
            </p>
            <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-gold-dark mb-8" data-id="element-286">
              A Subsidiary of Zylus Group
            </p>
          </div>

          {/* Links */}
          <div data-id="element-287">
            <h4 className="font-semibold text-ink mb-6" data-id="element-288">Properties</h4>
            <ul className="space-y-4 text-sm text-ink/60" data-id="element-289">
              <li data-id="element-290">
                <Link to="/houses" className="hover:text-gold transition-colors" data-id="element-291">
                  Premium Houses
                </Link>
              </li>
              <li data-id="element-292">
                <Link to="/land" className="hover:text-gold transition-colors" data-id="element-293">
                  Land & Plots
                </Link>
              </li>
              <li data-id="element-294">
                <Link to="/houses" className="hover:text-gold transition-colors" data-id="element-295">
                  Featured Estates
                </Link>
              </li>
              <li data-id="element-296">
                <Link to="/#book" className="hover:text-gold transition-colors" data-id="element-297">
                  Book Inspection
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-298">
            <h4 className="font-semibold text-ink mb-6" data-id="element-299">Company</h4>
            <ul className="space-y-4 text-sm text-ink/60" data-id="element-300">
              <li data-id="element-301">
                <Link to="/who-we-are" className="hover:text-gold transition-colors" data-id="element-302">
                  Who We Are
                </Link>
              </li>
              <li data-id="element-303">
                <Link to="/management-team" className="hover:text-gold transition-colors" data-id="element-304">
                  Management Team
                </Link>
              </li>
              <li data-id="element-305">
                <Link to="/board-of-directors" className="hover:text-gold transition-colors" data-id="element-306">
                  Board of Directors
                </Link>
              </li>
              <li data-id="element-307">
                <Link to="/certifications" className="hover:text-gold transition-colors" data-id="element-308">
                  Certifications
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-309">
            <h4 className="font-semibold text-ink mb-6" data-id="element-310">Media & Support</h4>
            <ul className="space-y-4 text-sm text-ink/60" data-id="element-311">
              <li data-id="element-312">
                <Link to="/blog" className="hover:text-gold transition-colors" data-id="element-313">
                  Zylus Blog
                </Link>
              </li>
              <li data-id="element-314">
                <Link to="/testimonials" className="hover:text-gold transition-colors" data-id="element-315">
                  Testimonials
                </Link>
              </li>
              <li data-id="element-316">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-317">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gold/20 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-ink/50" data-id="element-318">
          <p data-id="element-319">
            © {new Date().getFullYear()} Zylus Homes & Property. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-320">
            <a href="#" className="hover:text-ink transition-colors" data-id="element-321">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-ink transition-colors" data-id="element-322">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}